const LOCAL_STATIC_BASE = __ASSET_PATH__;
const DEV_OR_PROD_STAGING_STATIC_BASE = `${__ASSET_PATH__}/${__BRANCH__}`;
const PROD_STATIC_BASE = `${__ASSET_PATH__}/${__PKG_VERSION__}`;

// const conf = appConf;
const conf = {};

const isProdButNotProdStaging = __IS_PROD__ && !__IS_PROD_STAGING__;

conf.STATIC_BASE = __IS_LOCAL__ ? LOCAL_STATIC_BASE : DEV_OR_PROD_STAGING_STATIC_BASE;
conf.STATIC_BASE = __IS_PROD__ ? PROD_STATIC_BASE : conf.STATIC_BASE;
conf.STATIC_BASE = __IS_PROD_STAGING__ ? DEV_OR_PROD_STAGING_STATIC_BASE : conf.STATIC_BASE;
conf.DOCUMENT_BUCKET = `document.${isProdButNotProdStaging ? '' : 'dev-'}www.stridehealth.com`;
conf.BRANCH_KEY = 'key_live_egh4cYidygaBMNd1pTP9hmjfDDoyBtmM';
conf.DRIVE_BRANCH_URL = 'https://stride.app.link/g4wEYJhAHB';
conf.CONTENTFUL_SPACE_URL = 'https://images.ctfassets.net/heg7gyzix6dq';
// this is the fallback URL, FFM_URL_SAML is set in AWS env variable
conf.FFM_URL = isProdButNotProdStaging
  ? 'https://www.healthcare.gov/'
  : 'https://uat0.healthcare.gov/?ACA=kbV0uKB8cG';
/* eslint-disable no-nested-ternary */

conf.MARKETPLACE_BASE_URL = isProdButNotProdStaging
  ? 'https://marketplace-api.stridehealth.com'
  : 'https://dev-marketplace-api.stridehealth.com';

conf.MARKETPLACE_URL = `${conf.MARKETPLACE_BASE_URL}/graphql`;

conf.STRIDE_WEB_API_BASE_URL = __STRIDE_WEB_API_BASE_URL__;
conf.STRIDE_WEB_API_URL = `${conf.STRIDE_WEB_API_BASE_URL}graphql`;

conf.OPTIMIZELY_SDK_KEY = isProdButNotProdStaging
  ? 'YXYQTbm8azFBDAQQtfjxd9'
  : 'E9CGwfFMN6istedqBQJYxY';

conf.GOOGLE_MAP_API_KEY = 'AIzaSyDWWhB_txB-UYSFFWbGcZzM-vpYsdWArHM';

export default conf;
